import { twMerge } from 'tailwind-merge'

const variantStyles = {
  info: 'bg-zinc-50 dark:bg-zinc-900 border font-light',
  success: 'bg-green-50 text-green-800 dark:bg-green-900 dark:text-white',
  warning: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-900 dark:text-white',
  error: 'bg-red-50 dark:bg-red-200 text-red-800 dark:text-black',
}

type Props = {
  variant: keyof typeof variantStyles
  title?: React.ReactNode | string | any
  message?: React.ReactNode | string
  action?: React.ReactNode
  className?: string
} & ((React.ComponentPropsWithoutRef<'div'>))

export function Alert({ variant, title, message, action, className }: Props) {
  if (!message && !title) return null
  className = twMerge(
    'rounded-md p-4 text-base/7 md:text-sm/6',
    variantStyles[variant],
    className,
  )
  return (
    <div className={className}>
      {
        title && <div className='font-bold'>{title}</div>
      }
      <div>
        {message}
      </div>
      <div className='text-center'>
        {action}
      </div>
    </div>
  )
}